import Button from "@components/Button"
import { Form } from "react-router-dom"
import { Plan, StripePrice } from "src/types"

interface Props {
  buttonClassName?: string
  buttonTitle: string
  currency: string
  fullPrice: StripePrice | undefined
  isSubmitting: boolean
  plan: Plan
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
}

export default function SubscriptionForm({
  buttonClassName = "",
  buttonTitle,
  currency,
  fullPrice,
  isSubmitting,
  plan,
  priceId,
  setIsSubmitting,
}: Props) {
  const handleClick = () => {
    setIsSubmitting(true)
  }

  return (
    <Form onSubmit={handleClick} method="post">
      <input type="hidden" name="currency" value={currency} />

      <input type="hidden" name="plan" value={plan} />

      <input type="hidden" name="priceId" value={priceId} />

      <input type="hidden" name="nextPriceId" value={fullPrice?.id} />

      <input
        type="hidden"
        name="fullPrice"
        value={
          fullPrice?.currency_options[currency].unit_amount_decimal ??
          fullPrice?.unit_amount_decimal
        }
      />

      <Button
        className={buttonClassName}
        disabled={isSubmitting}
        title={buttonTitle}
        type="submit"
      />
    </Form>
  )
}
